/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusSearch({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        d="M82.222 44.38c27.08 0 49.109 22.03 49.109 49.11a48.8 48.8 0 0 1-7.633 26.253l22.615 22.74q.093.064.173.144c4.07 4.081 4.045 10.683-.032 14.748l-.004.004a10.4 10.4 0 0 1-7.358 3.031 10.4 10.4 0 0 1-7.397-3.069v.001l-22.634-22.752a48.8 48.8 0 0 1-26.84 8.01c-27.08 0-49.11-22.03-49.11-49.11s22.03-49.11 49.11-49.11m0 2.5c-25.7 0-46.61 20.91-46.61 46.61s20.91 46.61 46.61 46.61a46.3 46.3 0 0 0 26.293-8.151l.094-.059a1.25 1.25 0 0 1 1.498.209l23.361 23.479.295.282a7.9 7.9 0 0 0 5.329 2.05 7.9 7.9 0 0 0 5.596-2.306c3.058-3.049 3.116-7.964.161-11.072a1 1 0 0 1-.154-.131l-23.48-23.61a1.25 1.25 0 0 1-.154-1.573 46.3 46.3 0 0 0 7.77-25.728c0-25.7-20.91-46.61-46.61-46.61m0 14.17c17.89 0 32.439 14.55 32.439 32.44s-14.549 32.439-32.44 32.44-32.44-14.55-32.44-32.44 14.55-32.44 32.44-32.44m0 2.5c-16.51 0-29.94 13.43-29.94 29.94s13.43 29.94 29.94 29.94c16.509-.001 29.939-13.43 29.939-29.94s-13.43-29.94-29.94-29.94"
      />
      <path
        fill="#FAE100"
        d="M160.251 59.36h-53.23c-8.44 0-15.28 6.84-15.28 15.28v6.17c0 8.44 6.84 15.28 15.28 15.28h37.45v8.25c0 2.2 2.59 3.37 4.24 1.92l11.66-10.18c8.38-.07 15.15-6.88 15.15-15.27v-6.17c0-8.44-6.84-15.28-15.28-15.28z"
      />
      <path
        fill="#F9FAFB"
        d="M133.631 82.6a4.93 4.93 0 1 0 0-9.86 4.93 4.93 0 0 0 0 9.86m18.83 0a4.93 4.93 0 1 0 0-9.86 4.93 4.93 0 0 0 0 9.86m-37.66 0a4.93 4.93 0 1 0 0-9.86 4.93 4.93 0 0 0 0 9.86"
      />
    </svg>
  );
}
export default IllustStatusSearch;
